// extracted by mini-css-extract-plugin
export default {"subtitle":"MyPortals_subtitle__wuknj","actionBar":"MyPortals_actionBar__jSyY+","actions":"MyPortals_actions__1S5VY","dragHandler":"MyPortals_dragHandler__71mnh"};